import React from 'react';
import {Avatar} from '@mui/material';
import {AttachMoney, FlashOn, Person} from '@mui/icons-material';
import {getInitials, isLightColor, stringToColor} from '../../utils';
import {colors, registerGlobalStyle} from '../../theme';
import {ToolTip} from './ToolTip';
import {useUsersCache} from '../../hooks/api';

registerGlobalStyle('.user-avatar', () => ({
  '&.user-avatar': { // Need to be more specific than MUI
    overflow: 'hidden',
    backgroundColor: 'var(--avatar-color)',
    color: 'var(--avatar-text)',
  },
}));

export function UserAvatar({userId, name: _name, initials: _initials, color: _color, image: _image}) {
  const {data: {users}} = useUsersCache();

  // If userId is provided, find the user
  const user = (users && userId) ? users.find((u) => u._id === userId) : null;

  // Prefer user data if available, otherwise fallback to props
  const name = user?.fullName ?? _name;
  const initials = user?.initials ?? _initials;
  const color = user?.avatar?.color ?? _color;
  const image = user?.avatar?.image ?? _image;

  return (
    <>
      {(name || initials) &&
        <ToolTip tip={name} disabled={!name}>
          <Avatar className={'user-avatar'} style={getColors(name, color)} src={image}>
            {getIcon(name, initials)}
          </Avatar>
        </ToolTip>
      }
      {!(name || initials) &&
        <Avatar className={'user-avatar empty-avatar'} style={getColors(name, color)}/>
      }
    </>
  );
}

function getIcon(name, initials) {
  switch (name) {
    case 'Automation':
      return <FlashOn/>;

    case 'Customer':
      return <Person/>;

    case 'Accounts':
      return <AttachMoney/>;

    default:
      return initials ?? getInitials(name);
  }
}

function getColors(name, color) {
  if (color == null) {
    switch (name) {
      case 'Automation':
        color = colors.background.grey.dark;
        break;

      case 'Customer':
        color = colors.palette.blue;
        break;

      case 'Accounts':
        color = colors.background.contrastDark;
        break;

      default:
        color = stringToColor(name);
        break;
    }
  }

  return {'--avatar-color': color, '--avatar-text': isLightColor(color) ? colors.text.main : colors.palette.white};
}
